// action
import {
    GET_CHAT_BOT,
    GET_CHAT_BOT_FAIL,
    GET_CHAT_BOT_SUCCESS,
    GET_CHAT_BOT_RESET
} from '../action/getChatBotAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CHAT_BOT:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_CHAT_BOT_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_CHAT_BOT_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data,
            }
        case GET_CHAT_BOT_RESET:
            return initialState
        default:
            return state
    }
}